import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../api/axiosInstance"; 

// Async thunk to get user information from the backend
export const getUser = createAsyncThunk(
    'user/getUser',
    async (account, { rejectWithValue }) => {
        console.log('get user account', account);
        
        try {
            // Send a GET request to fetch user details
            const token = localStorage.getItem("token");
            const response = await axiosInstance.get('/trade/user', {
                params: { account }, // query param
                headers: {
                    "trade-account-token": token
                  }
            },
            
        );

            return response.data;  // Return the fetched user data
        } catch (error) {
            if (error.response) {
                console.error('Get User API error:', error.response.data);
                return rejectWithValue(error.response.data);  // Return detailed error from API
            } else {
                console.error('Network error:', error);
                return rejectWithValue('Network error');
            }
        }
    }
);

// Create a slice for managing user state
const userSlice = createSlice({
    name: 'user',
    initialState: {
        user: null,
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUser.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getUser.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.user = action.payload;  // Set the user data when the request is successful
                localStorage.setItem('user', JSON.stringify(action.payload));
            })
            .addCase(getUser.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;  // Set the error message when the request fails
            });
    },
});

export default userSlice.reducer;
